import {HTTP} from "@/utils/httpCommonUtil";

export async function updateFacilityContract(facilityId: any, data: any) {
  const response = await HTTP.post(`/api/facilities/${facilityId}/contract`, data);
  if (response.data.success) {
    return true;
  }
  throw new Error(response.data.message);
}

export async function getFacilityContract(facilityId: any): Promise<any> {
  const response = await HTTP.get(`/api/facilities/${facilityId}/contract`);
  return response.data;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/facility/cards/facilityContracts/service/FacilityContractService.ts